import axios from "axios";
import * as yup from "yup";
import {buildQuery} from "utils/queryUtils";

let schema = yup.object().shape({
    code: yup.string().test("not-blank", "code.required", (code) => code?.length > 0),
    name: yup.string().test("not-blank", "name.required", (name) => name?.length > 0),
});

export const validateSubject = (subject) => {
    return schema.validate(subject, {abortEarly: false});
};

export const findSubjects = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/subjects${query}`, {
        headers
    })
}

export const createSubject = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_IDP_API_URL}/subjects`, data, {
        headers
    })
}

export const updateSubject = (headers, id, data) => {
    return axios.patch(`${process.env.REACT_APP_IDP_API_URL}/subjects/${id}`, data, {
        headers
    })
}

export const deleteSubject = (headers, id) => {
    return axios.delete(`${process.env.REACT_APP_IDP_API_URL}/subjects/${id}`, {
        headers: headers,
    });
}

export const deleteSubjects = (headers, ids) => {
    return axios.delete(`${process.env.REACT_APP_IDP_API_URL}/subjects?id=${ids.join()}`, {
        headers: headers,
    });
}
